<template>
  <v-scale-transition>
    <v-btn
      v-if="$vuetify.breakpoint.lgAndUp"
      :disabled="disabled"
      :loading="loading"
      color="primary"
      @click.stop="$emit('click')"
    >
      <v-icon left>
        {{ icon }}
      </v-icon>
      {{ label }}
    </v-btn>
    <v-btn
      v-else
      :disabled="disabled"
      :loading="loading"
      color="primary"
      bottom
      dark
      fab
      fixed
      right
      @click.stop="$emit('click')"
    >
      <v-icon>
        {{ icon }}
      </v-icon>
    </v-btn>
  </v-scale-transition>
</template>

<script>
export default {
  name: 'BasePrimaryActionButton',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    icon: {
      type: String,
      default: 'mdi-plus',
    },

    label: {
      type: String,
      default: '',
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
